export const EMPLOYEE_NOTIFICATION_COOKIE_NAME =
  'employee-notification-dispatched'

export const TWELVE_HOURS_IN_SECONDS = 12 * 60 * 60
